var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "w-100 user-modal-register-confirmation-email-sent-view px-2",
    },
    [
      _c("div", { staticClass: "mb-5 text-center" }, [
        _c("p", { staticClass: "font-weight-bold font-size-200" }, [
          _vm._v(_vm._s(_vm._f("trans")("Check your email inbox now"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-center",
          class: {
            "mb-5": !_vm.shouldShowEducational,
            "mb-4": _vm.shouldShowEducational,
          },
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("p", {
            staticClass: "mb-0",
            domProps: { innerHTML: _vm._s(_vm.mainText) },
          }),
        ]
      ),
      _vm._v(" "),
      _vm.shouldShowEducational
        ? _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-between alert bg-education text-white mb-5 gap-75",
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { domProps: { innerHTML: _vm._s(_vm.educationText) } }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ButtonWithLoadingState", {
        staticClass:
          "btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-4",
        attrs: {
          "data-user-modal-button-submit": "",
          icon: "fa fa-arrow-right lh-1",
          text: _vm._f("trans")("Continue"),
          "is-state-loading": _vm.isSubmitting,
          "show-icon-after-text": true,
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.doContinue.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm._f("trans")("Didn't recieve an email?")) +
            "\n        "
        ),
        _c(
          "a",
          {
            class: { "link-inactive text-muted": _vm.disableResend },
            attrs: { "data-user-modal-link-resend-email": "", href: "#" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.resendConfirmation.apply(null, arguments)
              },
            },
          },
          [_vm._v(_vm._s(_vm._f("trans")("Re-send verification email")))]
        ),
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "mb-4 mt-4" }),
      _vm._v(" "),
      _c("div", { staticClass: "text-center mt-2" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm._f("trans")("Wrong email address?")) +
            "\n        "
        ),
        _c(
          "a",
          {
            attrs: { "data-user-modal-link-change-email": "", href: "#" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.goToDashboard.apply(null, arguments)
              },
            },
          },
          [_vm._v(_vm._s(_vm._f("trans")("Change email address")))]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-center mt-2" }, [
        _vm._v(
          "\n        " + _vm._s(_vm._f("trans")("Need help?")) + "\n        "
        ),
        _c(
          "a",
          {
            attrs: { "data-user-modal-link-help": "", href: "#" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.goToHelpPage.apply(null, arguments)
              },
            },
          },
          [_vm._v(_vm._s(_vm._f("trans")("Helpdesk")))]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "position-relative d-inline-block lh-1 mb-3" },
      [
        _c("i", {
          staticClass: "far fa-envelope",
          staticStyle: { "font-size": "75px", color: "#4285f4" },
        }),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-check-circle position-absolute",
          staticStyle: {
            bottom: "1px",
            right: "-13px",
            "font-size": "31px",
            color: "#00c851",
            background: "whitesmoke",
            "border-radius": "50%",
            "padding-top": "2px",
            "padding-right": "2px",
            "padding-left": "2px",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-inline-flex align-items-center" }, [
      _c("i", { staticClass: "far fa-graduation-cap font-size-200" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }